import React, { useState, useRef, useEffect } from 'react'
import { StyledTag, StyledTooltip } from './styles/TwoDaysTag.style'

interface Props {
  direction?: 'right' | 'left'
  openTooltip?: boolean
  isProduct?: boolean
}

const tooltipMessage = 'Produtos de parceiros geralmente possuem um prazo maior de entrega.'

const TwoDaysTag = ({ direction = 'left', openTooltip = true, isProduct = false }: Props) => {
  const [isOpen, setIsOpen] = useState(false)
  const textRef = useRef<HTMLDivElement>(null)

  const handleClickOutside = (event: MouseEvent) => {
    if (textRef.current && !textRef.current.contains(event.target as Node)) {
      setIsOpen(false)
    }
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  return (
    <div ref={textRef}>
      <StyledTag onClick={() => setIsOpen(!isOpen)}>
        {isProduct ? 'Parceiro' : 'Parceiro Clubbi'}
      </StyledTag>
      {isOpen && openTooltip && (
        <StyledTooltip direction={direction}>{tooltipMessage}</StyledTooltip>
      )}
    </div>
  )
}

export default TwoDaysTag
